import { render, staticRenderFns } from "./GiveAGiftModal.vue?vue&type=template&id=676e9aee"
import script from "./GiveAGiftModal.vue?vue&type=script&lang=ts"
export * from "./GiveAGiftModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports